export default {
  loadCategories ({state, commit}) {
    if (state.categories.length === 0) {
      return new Promise((resolve, reject) => {
        window.http.get('Categoria/GetCategoriasByFornecedor')
        .then((response) => {
          commit('loadCategories', response.data.resultado)
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toastrAxiosError', error)
        })
      })
    }
  },
  loadAllowedCategories ({state, commit}) {
    if (state.categories.length === 0) {
      return new Promise((resolve, reject) => {
        window.http.get('Categoria/GetCategoriasByFornecedorForScheduled')
        .then((response) => {
          commit('loadAllowedCategories', response.data.resultado)
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toastrAxiosError', error)
        })
      })
    }
  },
  loadPayments ({state, commit}) {
    if (state.categories.length === 0) {
      return new Promise((resolve, reject) => {
        window.http.get('Pagamento/GetPayments')
        .then((response) => {
          commit('loadPayments', response.data.resultado)
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toastrAxiosError', error)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/detalheCadastro/actions.js